import React, { useState } from "react";
import { ADULT, PEDIATRIC, chartOf } from "../lib/toothNumbers";
import { X } from "lucide-react";

// Compact tooth picker for use in Treatment plan. Emits selected tooth number.
const ToothPicker = ({ selected, onSelect, marked = {} }) => {
  const initial = selected ? chartOf(selected) : "adult";
  const [chartType, setChartType] = useState(initial);
  const T = chartType === "pediatric" ? PEDIATRIC : ADULT;

  const renderRow = (list) => (
    <div className="flex gap-1 justify-center">
      {list.map((tn) => {
        const isSel = String(selected) === String(tn);
        const has = marked[tn];
        return (
          <button
            key={tn}
            type="button"
            onClick={() => onSelect(isSel ? null : String(tn))}
            className={`w-7 h-8 rounded border text-[9px] font-semibold transition-all ${
              isSel
                ? "bg-[#14B8A6] text-white border-[#14B8A6] shadow"
                : has
                ? "bg-[#E6F7F5] text-[#0F8A7D] border-[#14B8A6]/40 hover:border-[#14B8A6]"
                : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"
            }`}
          >
            {tn}
          </button>
        );
      })}
    </div>
  );

  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4">
      <div className="flex items-center justify-between mb-3 gap-2">
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold text-slate-700">Select tooth (FDI)</span>
          {selected ? (
            <span className="inline-flex items-center gap-1 text-[10px] bg-[#14B8A6] text-white px-2 py-0.5 rounded font-mono font-bold">
              #{selected}
              <button type="button" onClick={() => onSelect(null)} className="ml-0.5 opacity-80 hover:opacity-100">
                <X size={10} />
              </button>
            </span>
          ) : (
            <span className="text-[10px] text-slate-400">None</span>
          )}
        </div>
        <div className="inline-flex rounded border border-slate-200 p-0.5 bg-slate-50">
          <button
            type="button"
            onClick={() => setChartType("adult")}
            className={`text-[10px] px-2 py-1 rounded font-medium ${
              chartType === "adult" ? "bg-white text-[#0F2A5F] shadow-sm" : "text-slate-500"
            }`}
          >
            Adult
          </button>
          <button
            type="button"
            onClick={() => setChartType("pediatric")}
            className={`text-[10px] px-2 py-1 rounded font-medium ${
              chartType === "pediatric" ? "bg-white text-[#0F2A5F] shadow-sm" : "text-slate-500"
            }`}
          >
            Pediatric
          </button>
        </div>
      </div>

      <div className="space-y-1.5">
        <div className="flex items-center gap-2">
          <div className="text-[9px] w-4 text-right text-slate-400">UR</div>
          {renderRow(T.UPPER_RIGHT)}
          <div className="w-px h-6 bg-slate-200 mx-0.5" />
          {renderRow(T.UPPER_LEFT)}
          <div className="text-[9px] w-4 text-left text-slate-400">UL</div>
        </div>
        <div className="flex items-center gap-2">
          <div className="text-[9px] w-4 text-right text-slate-400">LR</div>
          {renderRow(T.LOWER_RIGHT)}
          <div className="w-px h-6 bg-slate-200 mx-0.5" />
          {renderRow(T.LOWER_LEFT)}
          <div className="text-[9px] w-4 text-left text-slate-400">LL</div>
        </div>
      </div>

      <p className="text-[10px] text-slate-400 mt-2">
        Tip: Pick a tooth, then click any treatment on the right to add it for that tooth.
      </p>
    </div>
  );
};

export default ToothPicker;
